import qs from 'query-string'
import client from '@/store/client'
import { parseStringPromise } from 'xml2js'
import parseData from '../util/parsedata'
import _ from 'lodash'

const getDefaultState = () => {
  return {
    orgSiteInfo: {
      name: ''
    },
    retailerID: 0,
    siteInfo: {},
    pretailers: [],
    siteGroup: [],
    promotionTypes: [],
    promotions: [],
    headers: [
      {
        text: 'Attached',
        sortable: true,
        value: 'IsAttachedToSite',
        width: '25'
      },
      {
        text: 'Prtailer ID',
        sortable: true,
        value: 'ID'
      },
      {
        text: 'Name',
        sortable: true,
        value: 'Name'
      }
    ]
  }
}

export default {
  namespaced: true,
  state: getDefaultState(),
  actions: {
    SET_FIELD: ({ commit }, data) => {
      commit('setField', data)
    },
    SET_FIELD_OBJ: ({ commit }, data) => {
      commit('setFieldObj', data)
    },
    RESET: ({ commit }) => {
      commit('reset')
    },
    SET_SITE: async function({ commit }, data ) {
      try {
        this.dispatch('loader/CHANGE', {
          status: 'LOADING',
          detail: 'Getting Data',
          subdetail: 'Please wait',
        })
        const apiData = {
          ...this.getters['traceToken'],
          siteID: data.siteID,
        }
        const siteAPI = await client.post('/v1/Site.asmx/GetSite', qs.stringify(apiData))
        const parsedata = await parseStringPromise(siteAPI.data)
        commit('setSite', parsedata.content.data[0].$)
        commit('setField', { key: 'retailerID', value: data.retailerID })
        this.dispatch('loader/CHANGE', {
          status: 'COMPLETE',
          detail: 'Redirecting...',
          subdetail: '',
        })
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong.',
          subdetail: err.response.data,
        })
      }
    },
    UPDATE_SITE: async function({state}){
      try {
        this.dispatch('loader/CHANGE', {
          status: 'LOADING',
          detail: 'Updating Site',
          subdetail: 'Please wait...',
        })
        await client.post('/v1/Site.asmx/UpdateSite', qs.stringify({...this.getters['traceToken'], ...state.siteInfo, promotionTypeID: state.siteInfo.DefaultPromotionChildTypeID || 0, SiteID: state.siteInfo.ID}))
        this.dispatch('site/SET_SITE', { retailerID: state.retailerID, siteID: state.siteInfo.ID} )
        this.dispatch('loader/CHANGE', {
          status: 'COMPLETE',
          detail: 'Logging in',
          subdetail: '',
        })
        this.dispatch('ui/SET_TOAST', { message: `Site has been successfully updated`, color: 'green', delay: 2500 })
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong.',
          subdetail: err.response.data,
        })
      }
    },
    GET_PRETAILER: async function({commit}){
      try {
        const APIRes = await client.post('/v2/Site.asmx/FindPretailers', qs.stringify(this.getters['site/APIData']))
        commit('setPRetailers', await parseData(APIRes.data))
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong.',
          subdetail: err.response.data,
        })
      }
    },
    ATTACH_DETACH_PRETAILER: async function( {getters,dispatch}, data){
      try {
        this.dispatch('loader/CHANGE', {
          status: 'LOADING',
          detail: 'Updating',
          subdetail: 'Please wait...',
        })
        const APICall = {
          ...getters['APIData'],
          ...data
        }
        await client.post('/v1/Site.asmx/AttachOrDetachPRetailer', qs.stringify(APICall))
        await dispatch('GET_PRETAILER')
        this.dispatch('loader/CHANGE', {
          status: 'COMPLETE',
          detail: 'Logging in',
          subdetail: '',
        })
        this.dispatch('ui/SET_TOAST', { message: `PRtailer ${ data.pretailerID } has been successfully updated`, color: 'green', delay: 2500 })
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong.',
          subdetail: err.response.data,
        })
      }
    },
    GET_SITE_GROUP: async function({commit}, data){
      try {
        const APIRes = await client.post('/v2/Site.asmx/FindSiteGroupSiteAttachment', qs.stringify({...this.getters['traceToken'], siteID: data}))
        commit('setSiteGroup', await parseData(APIRes.data))
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong.',
          subdetail: err.response.data,
        })
      }
    },
    ATTACH_DETACH_SITE_GROUP: async function( {getters,dispatch}, data){
      try {
        this.dispatch('loader/CHANGE', {
          status: 'LOADING',
          detail: 'Updating Site Group',
          subdetail: 'Please wait...',
        })
        const APICall = {
          ...getters['APIData'],
          ...data
        }
        await client.post('/v1/SiteGroup.asmx/AttachOrDetachSiteWithSitegroup', qs.stringify(APICall))
        await dispatch('GET_SITE_GROUP', APICall.siteID)
        this.dispatch('ui/SET_TOAST', { message: `Site group ${ data.siteGroupId } has been successfully updated`, color: 'green', delay: 2500 })
        this.dispatch('loader/CHANGE', {
          status: 'COMPLETE',
          detail: 'Redirecting...',
          subdetail: '',
        })
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong.',
          subdetail: err.response.data,
        })
      }
    },
    GET_SITE_PRETAILER_PROMO_TYPES: async function({commit}, data){
      try {
        const APIRes = await client.post('/v2/SitePRetailer.asmx/FindPromotionTypesSitePRetailer', qs.stringify({...this.getters['traceToken'], pretailerID: data.pRetailer, SiteID: data.siteID}))
        commit('setPromotionTypes', await parseData(APIRes.data))
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong.',
          subdetail: err.response.data,
        })
      }
    },
    ATTACH_DETACH_PROMO_TYPE: async function( {getters,dispatch}, data){
      try {
        this.dispatch('loader/CHANGE', {
          status: 'LOADING',
          detail: 'Updating',
          subdetail: 'Please wait...',
        })
        const APICall = {
          ...getters['APIData'],
          ...data
        }
        await client.post('/v1/SitePRetailer.asmx/AttachOrDetachPromotionType', qs.stringify(APICall))
        await dispatch('GET_SITE_PRETAILER_PROMO_TYPES', { pRetailer: data.pretailerID, siteID: this.state.site.siteInfo.ID })
        this.dispatch('loader/CHANGE', {
          status: 'COMPLETE',
          detail: 'Logging in',
          subdetail: '',
        })
        this.dispatch('ui/SET_TOAST', { message: `Promotion type successfully updated`, color: 'green', delay: 2500 })
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong.',
          subdetail: err.response.data,
        })
      }
    },
    GET_SITE_PROMO: async function({commit}, data){
      try {
        const APIRes = await client.post('/v2/SitePRetailer.asmx/FindPromotions', qs.stringify({...this.getters['traceToken'], ...data}))
        commit('setPromotions', await parseData(APIRes.data))
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong.',
          subdetail: err.response.data,
        })
      }
    },
    ATTACH_DETACH_PROMO: async function( {getters,dispatch}, data){
      try {
        this.dispatch('loader/CHANGE', {
          status: 'LOADING',
          detail: 'Updating',
          subdetail: 'Please wait...',
        })
        const APICall = {
          ...getters['APIData'],
          ...data
        }
        await client.post('/v1/SitePRetailer.asmx/AttachOrDetachSitePretailerPromotion', qs.stringify(APICall))
        await dispatch('GET_SITE_PROMO', { pretailerID: data.pretailerID, siteID: this.state.site.siteInfo.ID })
        this.dispatch('loader/CHANGE', {
          status: 'COMPLETE',
          detail: 'Logging in',
          subdetail: '',
        })
        this.dispatch('ui/SET_TOAST', { message: `Promotion type successfully updated`, color: 'green', delay: 2500 })
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong.',
          subdetail: err.response.data,
        })
      }
    }
  },
  getters: {
    siteChanged: state => !_.isEqual(state.orgSiteInfo, state.siteInfo),
    APIData: (state, getters, rootState, rootGetters) => {
      return {
        ...rootGetters['traceToken'],
        retailerID: state.retailerID,
        siteID: state.siteInfo.ID
      }
    },
    pretailers: state => {
      return state.pretailers.map( item => {
        if (item.IsAttachedToSite == 'false') item.IsAttachedToSite = false
        else item.IsAttachedToSite = true 
        return item
      })
    },
    siteGroup: state => {
      return state.siteGroup.map( item => {
        if (item.IsAttachedToSite == 'false') item.IsAttachedToSite = false
        else item.IsAttachedToSite = true 
        return item
      })
    },
    promotionType: state => {
      return state.promotionTypes.map( item => {
        if (item.IsAttachedToSite == 'false') item.IsAttachedToSite = false
        else item.IsAttachedToSite = true 
        return item
      })
    },
    promotions: state => {
      return state.promotions.map( item => {
        if (item.IsAttachedToSite == 'false') item.IsAttachedToSite = false
        else item.IsAttachedToSite = true 
        return item
      })
    },
  },
  mutations: {
    setField: function(state, data) {
      state[data.key] = data.value
    },
    setFieldObj: function(state, data) {
      state[data.obj][data.key] = data.value
    },
    reset: function(state) {
      Object.assign(state, getDefaultState())
    },
    setPRetailers: function(state, data) {
      state.pretailers = data
    },
    setSiteGroup: function(state, data) {
      state.siteGroup = data
    },
    setSite: function(state, data) {
      state.siteInfo = data
      state.orgSiteInfo = _.cloneDeep(data)
    },
    setPromotionTypes: function(state, data) {
      state.promotionTypes = data
    },
    setPromotions: function(state, data) {
      state.promotions = data
    },
  },
}
